import { render, staticRenderFns } from "./register_Mobile.vue?vue&type=template&id=0a5f392f&"
import script from "./register_Mobile.vue?vue&type=script&lang=js&"
export * from "./register_Mobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports